<ng-container *ngIf="obligacionesCerradas && obligacionesCerradas.length == 0">
  <div class="no-hay-informacion">
    <label>{{ "PERFILCREZCAMOS.MSG_NOENCONTROINFORMACIONPORMOSTRAR" | translate }}</label>
  </div>
</ng-container>
<div *ngIf="obligacionesCerradas && obligacionesCerradas.length > 0">
  <p-table
    class="tabla-gris"
    [columns]="columnas"
    [value]="obligacionesCerradas"
    [paginator]="true"
    [rows]="10"
    [responsive]="true"
    paginatorPosition="bottom"
  >
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th
          *ngFor="let col of columns"
          [pSortableColumn]="col.field"
          [pSortableColumnDisabled]="!col.sort"
          class="text-center"
        >
          {{ col.header }}
          <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-row>
      <tr [pSelectableRow]="row">
        <td class="text-center">{{ row.participacion ? row.participacion : ("-" | translate) }}</td>
        <td class="text-center">
          {{ row.numeroCredito ? row.numeroCredito : ("-" | translate) }}
        </td>
        <td class="text-center width-column">
          {{ row.fechaDesembolso ? (row.fechaDesembolso | date:'yyyy-MM-dd') : ("-" | translate) }}
        </td>
        <td class="text-center width-column">
          {{ row.fechaCierre ? (row.fechaCierre | date:'yyyy-MM-dd') : ("-" | translate) }}
        </td>
        <td class="text-center">
          {{
            row.montoDesembolsado
              ? (row.montoDesembolsado / 1000 | dinero : 0)
              : ("-" | translate)
          }}
        </td>
        <td class="text-center">
          {{
            row.liquidez
              ? (row.liquidez / 1000 | dinero : 0)
              : ("-" | translate)
          }}
        </td>
        <td class="text-center">
          {{
            ( row.actividadEconomica !== null ? row.actividadEconomica : row.oficio !== null ? row.oficio : "-" ) | translate
          }}
        </td>
        <td class="text-center">
          {{ row.garantia ? row.garantia : ("-" | translate) }}
        </td>
        <td class="text-center">
          <div class="btn-group">
            <div class="contador-firmantes">
              <i class="fa fa-user-o" aria-hidden="true"></i>
              {{
                row.numeroFirmantes || row.numeroFirmantes === 0
                  ? row.numeroFirmantes
                  : "-"
              }}
            </div>
            <button
              type="button"
              class="p-button btn"
              icon="fa fa-eye"
              data-toggle="tooltip"
              title="{{ 'BTN_VISUALIZAR' | translate }}"
              (click)="visualizarFirmantes(row)"
              pButton
            ></button>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <tr>
        <td class="text-center" [attr.colspan]="columns.length">
          {{ "MSG_NOHAYREGISTROS" | translate }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>

<p-dialog
  [draggable]="false"
  [resizable]="false"
  [closable]="true"
  [responsive]="true"
  [closeOnEscape]="true"
  [(visible)]="showFirmantes"
  *ngIf="showFirmantes"
  [contentStyle]="{ width: '600px' }"
  header="{{ ('PERFILCREZCAMOS.LBL_FIRMANTESOBLIGACIONCERRADO' | translate) + ' ' + numeroCredito }}"
  [modal]="true"
>
  <div class="grid">
    <div class="col-12 lg:col-12 md:col-12">
      <p-table
        [value]="firmantes"
        class="tabla-gris"
        [columns]="columnasFirmantes"
        [paginator]="true"
        [rows]="10"
        [responsive]="true"
        paginatorPosition="bottom"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-row>
          <tr [pSelectableRow]="row">
            <td class="text-center">
              {{ row.nombreCompleto ? row.nombreCompleto : ( "-" | translate ) }}
            </td>
            <td class="text-center">
              {{ row.codigoTipoDocumento ? row.codigoTipoDocumento : ( "-" | translate ) }}
            </td>
            <td class="text-center">
              {{ row.numeroDocumento ? row.numeroDocumento : ( "-" | translate ) }}
            </td>
            <td class="text-center">
              {{ row.vinculacion   ? row.vinculacion   : ( "-" | translate ) }}
            </td>
            <td class="text-center">
              {{ row.parentesco ? row.parentesco : ( "-" | translate  ) }}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td class="text-center" [attr.colspan]="columns.length">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="grid form-footer-buttons">
    <div class="form-group col-12">
      <button
        icon="fa fa-close"
        label="{{ 'BTN_CERRAR' | translate }}"
        type="button"
        pButton
        (click)="cerrarFirmantes()"
      ></button>
    </div>
  </div>
</p-dialog>
